@if (!editing) {
  <div
    class="editable url-wrapper flex flex-row"
    tabindex="-1"
    [ngClass]="{ readonly: readonly }"
    [matTooltip]="showTip"
    [class.locked]="fieldDef.locked"
  >
    @if (isNestedField) {
      @for (item of value; track item.label; let last = $last) {
        <span class="underline">
          <a href="{{ item.label }}" target="_blank">{{ item.label }}</a>
        </span>
        @if (!last) {
          <span>, </span>
        }
      }
    } @else {
      <span class="underline">
        <a href="{{ value }}" target="_blank">{{ value }}</a>
      </span>
      <button class="remove-email-field-url mr-2" type="button" mat-icon-button (click)="edit()" matTooltip="Edit">
        <mat-icon [svgIcon]="'edit'"></mat-icon>
      </button>
    }
  </div>
} @else {
  <input
    #inputEditorControl
    type="text"
    tabindex="-1"
    [maxLength]="1024"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    (blur)="onBlur()"
    (keyup.enter)="onBlur()"
  />
}
